"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 2/16/2017.
 */
var DataPointGroup = /** @class */ (function () {
    function DataPointGroup(dataPoints, periods) {
        this.dataPoints = dataPoints;
        this.periods = periods;
        this.initDataPointsWithoutFooterComment();
    }
    DataPointGroup.prototype.dataPointColspan = function () {
        return this.hasPeriodicity() ? this.periods.length : 1;
    };
    DataPointGroup.prototype.periodColspan = function () {
        return this.dataPointsInHeaderSize();
    };
    DataPointGroup.prototype.hasPeriodicity = function () {
        if (!this.periods) {
            return false;
        }
        else if (this.periods.length === 0) {
            return false;
        }
        return true;
    };
    /**
     * Method return DataPoints count that have Disaggregation.
     * @returns {number}
     */
    DataPointGroup.prototype.dataPointsWithDisaggregationSize = function () {
        var count = 0;
        for (var _i = 0, _a = this.dataPoints; _i < _a.length; _i++) {
            var dataPoint = _a[_i];
            if (dataPoint.disaggregationIds.length > 0) {
                count++;
            }
        }
        return count;
    };
    /**
     * Method return DataPoints count that have Disaggregation.
     * @returns {number}
     */
    DataPointGroup.prototype.dataPointsInHeaderSize = function () {
        var count = 0;
        for (var _i = 0, _a = this.dataPoints; _i < _a.length; _i++) {
            var dataPoint = _a[_i];
            if (!(dataPoint.isComment() && dataPoint.disaggregationIds.length == 0)) {
                count++;
            }
        }
        return count;
    };
    /**
     * Method init list of all DataPoints, without comment DataPoints, that have not assigned disaggregation(s) (_dataPointsWithoutFooterComment)
     * and  .
     */
    DataPointGroup.prototype.initDataPointsWithoutFooterComment = function () {
        this.dataPointsWithoutFooterComment = new Array();
        for (var _i = 0, _a = this.dataPoints; _i < _a.length; _i++) {
            var dataPoint = _a[_i];
            if (!(dataPoint.dataFormat.comment && dataPoint.disaggregationIds.length == 0)) {
                this.dataPointsWithoutFooterComment.push(dataPoint);
            }
            else {
                this.commentDataPoint = dataPoint;
            }
        }
    };
    DataPointGroup.prototype.getCommentDataPointItemColspan = function () {
        return this.dataPoints.length - this.dataPointsWithoutFooterComment.length; //TODO G.A. stugel. N/D i hamar nayel M&E-DE-Core um inchpes e arvac
    };
    return DataPointGroup;
}());
exports.DataPointGroup = DataPointGroup;
//# sourceMappingURL=data-point-group.model.js.map